import { render, staticRenderFns } from "./ProjectPersonEdit.vue?vue&type=template&id=b7ef0d58&"
import script from "./ProjectPersonEdit.vue?vue&type=script&lang=js&"
export * from "./ProjectPersonEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports